import React from 'react';

const Ratings = ({ productCode, setRef, display }) => (
  <div
    key={`bv-ratings_${productCode}`}
    ref={ref => setRef(ref, 'ratings')}
    className={`pdp-form__title-stars-rating ${display ? '' : 'display-none'}`}
    id="pdp-details-ratings-container"
  >
    <div className="bv-ratings" data-bv-show="rating_summary" data-bv-product-id={productCode} />
  </div>
);

export default Ratings;
